module.exports = __webpack_public_path__ + "img/chelysheva.e3c066f1.jpg";